import React from 'react';

// Prefixo da corretora no TradingView (casa com o nome interno da exchange da ordem).
const TV_EXCHANGE_PREFIX = {
    BINANCE: 'BINANCE',
    BYBIT: 'BYBIT',
    OKX: 'OKX',
    BITGET: 'BITGET',
};

/**
 * Abre o gráfico do símbolo no TradingView em nova aba.
 * props:
 * - symbol   (ex: 'BTCUSDT')
 * - exchange (ex: 'BINANCE' — opcional; default BINANCE)
 * - title
 */
function RowChartButton(props) {
    function openChart() {
        if (!props.symbol) return;
        const prefix = TV_EXCHANGE_PREFIX[(props.exchange || 'BINANCE').toUpperCase()] || 'BINANCE';
        const url = `https://www.tradingview.com/chart/?symbol=${prefix}:${props.symbol}`;
        window.open(url, '_blank', 'noopener,noreferrer');
    }

    return (
        <button type='button' className='btn btn-secondary btn-xs ms-2' title={props.title || 'Ver gráfico no TradingView'} onClick={openChart}>
            <svg className="icon icon-xs" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 11a1 1 0 011-1h2a1 1 0 011 1v5a1 1 0 01-1 1H3a1 1 0 01-1-1v-5zM8 7a1 1 0 011-1h2a1 1 0 011 1v9a1 1 0 01-1 1H9a1 1 0 01-1-1V7zM14 4a1 1 0 011-1h2a1 1 0 011 1v12a1 1 0 01-1 1h-2a1 1 0 01-1-1V4z" /></svg>
        </button>
    );
}

export default RowChartButton;
